import { z } from 'zod';
export const reminderSubstitutionsSchema = z.object({
    counterStart: z.number().int().min(0).max(1000000000),
    counterStep: z.number().int().min(1).max(1000000),
});
//# sourceMappingURL=reminder-substitutions.js.map